import * as R from 'ramda';

export const getNotDisplayedCombinations = (annotation = {}) => {
  const splitTitle = R.split(',', annotation.title || '');
  return R.reduce(
    (acc, entry) => {
      const [dId, values = ''] = R.split('=', entry);
      const match = values.match(/\((.*?)\)/);
      if (!match) {
        return acc;
      }
      const content = R.nth(1, match);
      return R.isEmpty(content)
        ? acc
        : { ...acc, [dId]: R.reject(R.isEmpty, R.split('+', content)) };
    },
    {},
    splitTitle,
  );
};

const getNotDisplayedValues = annot => {
  if (R.isNil(annot)) {
    return {};
  }
  const ids = R.split(',', annot.title || '');
  return R.reduce(
    (acc, entry) => {
      if (R.isEmpty(entry)) {
        return acc;
      }
      const parsed = R.split('=', entry);
      const dimensionId = parsed[0];
      if (R.length(parsed) === 1) {
        return R.assoc(dimensionId, dimensionId, acc);
      }
      const values = R.split('+', parsed[1]);
      if (R.length(values) === 1 && R.isEmpty(values[0])) {
        return R.assoc(dimensionId, dimensionId, acc);
      }
      return R.reduce(
        (_acc, val) => {
          let _val = val;
          if (R.isEmpty(val)) {
            return _acc;
          }
          if (R.test('/[()]/')) {
            _val = R.replace(/[()]/g, '')(val);
          }
          const key = R.isEmpty(_val) ? dimensionId : `${dimensionId}.${_val}`;
          return R.assoc(key, key, _acc);
        },
        acc,
        values,
      );
    },
    {},
    ids,
  );
};

export const getNotDisplayedIds = annotations =>
  R.pipe(
    R.find(R.propEq('NOT_DISPLAYED', 'type')),
    R.converge(
      (hiddenValues, hiddenCombinations) => ({
        hiddenValues,
        hiddenCombinations,
      }),
      [getNotDisplayedValues, getNotDisplayedCombinations],
    ),
  )(annotations);
